import { render } from "./Mpesa_Transactions.vue?vue&type=template&id=5ff205d4"
import script from "./Mpesa_Transactions.vue?vue&type=script&lang=js"
export * from "./Mpesa_Transactions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__